import PropTypes, { string } from 'prop-types'
import { positionPropType } from '../common/position-prop-type.js'

/**
 * @typedef {Object} stpParkingInformationFeature
 *
 * @property {string}  [name]   - Parking feature name
 * @property {string}  [type]   - Parking feature type
 */
const stpParkingInformationFeaturePropType = PropTypes.shape({
    name: string,
    type: string
})

/**
 * @typedef {Object} StpParkingInformation
 *
 * @property {string}  [id]               - Secure Truck Parking id
 * @property {string}  [name]             - Secure Truck Parking name
 * @property {string}  [description]      - Secure Truck Parking description
 * @property {addressPropType}  [address] - Secure Truck Parking address
 * @property [{stpParkingInformationFeaturePropType}]  [features] - Secure Truck Parking features
 * @property {string}  [fees]      - Secure Truck Parking fees
 * @property {string}  [openingHours]      - Secure Truck Parking openingHours
 * @property {string}  [image]      - Secure Truck Parking image
 * @property {string}  [providerName]      - Secure Truck Parking providerName
 */
const stpParkingInformationPropType = PropTypes.shape({
    id: string.isRequired,
    name: string,
    description: string,
    address: PropTypes.shape({
        name: string,
        street: string,
        city: string,
        zip: string,
        countryCode: string,
        position: positionPropType
    }),
    features: PropTypes.arrayOf(stpParkingInformationFeaturePropType),
    fees: string,
    openingHours: string,
    image: string,
    providerName: string
})

export { stpParkingInformationFeaturePropType, stpParkingInformationPropType }
